import React from "react";
import Accordion from "react-bootstrap/Accordion";
import PaginationModified from "../../../../data/PaginationModified";

const PTTransferDetailsMobile = ({
  tableData,
  tablePagination,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
}) => {
  function getPagination() {
    try {
      const pagination = tablePagination ? tablePagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }
  
  return (
    <div className="all-leads-log">
      {tableData?.length > 0 &&
        tableData.map((row, index) => {
          return (
            <div className="log-card" key={index}>
              <div className="all-info" style={{ rowGap: "1rem" }}>
                <div className="log-card-top">
                  <div
                    className="profile-name-number"
                    style={{
                      columnGap: "0",
                      height: "auto",
                    }}
                  >
                    <div className="name-number">
                      <h3 className="lead-name">{row?.user_name || "NA"}</h3>
                      <p className="number">{row?.user_mobile || "NA"}</p>
                      {row?.email ? (
                        <span className="value email semi-bold">
                          {row?.user_email || "NA"}
                        </span>
                      ) : null}
                    </div>
                  </div>
                </div>

                <div className="all-followuo-info-container">
                  <Accordion>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header style={{ padding: "0 10px 10px 10px" }}>
                        Show More
                      </Accordion.Header>

                      <Accordion.Body>
                        <div className="lead-multi-value-cols px20px pb20px">
                          <div className="label-value flex-col">
                            <span className="label underline">
                              trainer detail
                            </span>

                            <span className="value">
                              {row?.trainer_name || "NA"}
                              <br />
                              <small className="lowercase">
                                {row?.trainer_mobile || ""}
                                <br />
                                {row?.trainer_email || ""}
                              </small>
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">session No</span>
                            <span
                              className="value"
                              style={{
                                background: "#FFB200",
                                color: "#fff",
                                padding: "5px 15px",
                                borderRadius: "8px",
                              }}
                            >
                              {row?.session_no || 0}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">date</span>
                            <span className="value">{row?.date || "-"}</span>
                          </div>

                          <div className="label-value">
                            <span className="label">Status</span>
                            <span
                              className="value"
                              style={{
                                background:
                                  row?.status === "pending"
                                    ? "#FFEDC0"
                                    : row?.status === "completed" ||
                                      row?.status === "verified"
                                    ? "#B4E7B9"
                                    : "#F3DADA",
                                color:
                                  row?.status === "pending"
                                    ? "#171717"
                                    : row?.status === "completed" ||
                                      row?.status === "verified"
                                    ? "#0A701B"
                                    : "#D90000",
                                borderRadius: "10px",
                                padding: "10px",
                              }}
                            >
                              {row?.status || "NA"}
                            </span>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </div>
            </div>
          );
        })}

      <div className="lead-logs-card-pagination">
        <PaginationModified
          isPage={isPage}
          onChangePage={setIsPage}
          pagination={getPagination()}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      </div>
    </div>
  );
};

export default PTTransferDetailsMobile;
